/**
 * 객체 설정 > 시간 객체 Store
 *
 * @since 2018-06-12
 * @author kdydesign.kim
 */

import {ObjectSecProfileApiPrefix as objApiPrefix, CmApiPrefix as cmApiPrefix} from 'utils'

import {formatDate} from '~/utils/date'
// TAMS
import { getTimeObjectList, computedSetTimeData } from 'objectSettingsUtils'

const initTimeData = () => {
  return {
    // name: void 0,
    // desc: void 0,
    week: {
      sun: {use: 1, exp: ['00002359']},
      mon: {use: 1, exp: ['00002359']},
      tue: {use: 1, exp: ['00002359']},
      wed: {use: 1, exp: ['00002359']},
      thu: {use: 1, exp: ['00002359']},
      fri: {use: 1, exp: ['00002359']},
      sat: {use: 1, exp: ['00002359']}
    },
    month: {
      use: 0,
      week: '000000',
      period: '18-18',
      days: '0000000000000000000000000000000'
    },
    year: {
      use: 0,
      exp: '000000000000'
    },
    period: {
      use: 0,
      exp: []
    },
    // TAMS
    time_obj_uname: void 0,
    time_obj_desc: void 0,
    cfg_layer: 1
  }
}

// TAMS 미사용
// const isShowRefs = (newObj, oldObj) => {
//   const refObj = _.get(newObj, ['ref'], {})
//   let isRefs = false
//   if (Number(_.get(newObj, ['tm_obj_id'], -1)) === 0) { // Any는 refs가 없어도 변경사항 체크
//     isRefs = true
//   } else {
//     Object.keys(refObj).forEach((key) => {
//       if (!/ref$/.test(key)) return
//       if (refObj[key] === true && ['fw_ref', 'fw6_ref', 'nat_ref'].indexOf(key) >= 0) {
//         isRefs = true
//       }
//     })
//   }
//
//   if (!isRefs) return false
//   // #31916 - 이슈에서 정의
//   let pickList = ['week', 'month', 'year', 'period']
//   const newD = _.pick(newObj, pickList)
//   const oldD = _.pick(oldObj, pickList)
//   const res = !_.isEqual(JSON.stringify(newD), JSON.stringify(oldD))
//   return res
// }

export const state = () => ({
  selectedData: void 0,
  timeData: initTimeData(),
  timeObjectDataList: [],
  copyData: void 0
})

export const mutations = {
  // 현재 시간으로 월 - 기간 설정
  changeMonthPeriod (state, data) {
    state.timeData.month.period = `${data}-${data}`
  },

  resetTimeCopyData (state) {
    state.copyData = void 0
  },

  // 선택된 객체 초기화
  resetObjectSelectData (state) {
    state.selectedData = void 0
  },

  // 시간 객체 선택
  selectedTimeObject (state, data) {
    state.selectedData = data
  },

  // 시간 객체 초기화
  resetTimeObjectData (state) {
    state.timeData = initTimeData()
  },

  // 시간 객체: 매주 요일별 시간 추가/삭제
  changeWeekExp (state, {key, type, index}) {
    const exp = state.timeData.week[key].exp

    if (type === 'add') {
      exp.push('00002359')
    } else {
      exp.splice(index, 1)
    }
  },

  // 시간 객체: 매주 요일별 시간 추가/삭제
  changeWeekPeriod (state, {type, index, agentTime}) {
    const exp = state.timeData.period.exp
    const result = formatDate(agentTime, 'YYYYMMDD') + formatDate(agentTime, 'YYYYMMDD')

    if (type === 'add') {
      exp.push(result)
    } else {
      exp.splice(index, 1)
    }
  },

  // 시간 객체 목록 조회
  getTimeObjectDataList (state, data) {
    state.timeObjectDataList = Object.freeze(getTimeObjectList(data))
  },

  // 시간 객체 목록 초기화
  resetTimeObjectDataList (state) {
    state.timeObjectDataList = []
  },

  // 시간 객체 저장
  saveTimeObjectData (state, data) {
    const timeObjectDataList = _.cloneDeep(state.timeObjectDataList)

    timeObjectDataList.unshift(data)

    state.timeObjectDataList = Object.freeze(timeObjectDataList)
  },

  // 시간 객체 수정
  updateTimeObjectData (state, data) {
    state.timeObjectDataList = Object.freeze(_.map(state.timeObjectDataList, (o) => {
      if (o.tm_obj_id === data.tm_obj_id) {
        o = data
      }
      return o
    }))
  },

  // 시간 객체 조회
  getTimeObjectData (state, data) {
    // TAMS
    const result = getTimeObjectList(data)
    state.timeData = result[0]
  },

  // 시간 객체 삭제
  deleteTimeObjectData (state, data) {
    const timeObjectDataList = _.cloneDeep(state.timeObjectDataList)
    const itemIndex = _.findIndex(timeObjectDataList, {tm_obj_id: data})

    timeObjectDataList.splice(itemIndex, 1)

    state.timeObjectDataList = Object.freeze(timeObjectDataList)
  },

  // 시간 객체 일괄 삭제
  deleteBatchTimeObjectData (state, data) {
    const timeObjectDataList = _.cloneDeep(state.timeObjectDataList)

    _.forEach(data, (o) => {
      const itemIndex = _.findIndex(timeObjectDataList, {tm_obj_id: o.tm_obj_id})

      timeObjectDataList.splice(itemIndex, 1)
    })

    state.timeObjectDataList = Object.freeze(timeObjectDataList)
  },

  // 기간 날짜 기본 설정
  setDefaultDate (state, data) {
    const result = formatDate(data, 'YYYYMMDD0000') + formatDate(data, 'YYYYMMDD2359')

    state.timeData.period.exp = [result]
  },

  // 방화벽 정책 기간 날짜 기본 설정
  setFwTimeDefaultDate (state, {start, end}) {
    const result = formatDate(start, 'YYYYMMDD0000') + formatDate(end, 'YYYYMMDD2359')

    state.timeData.period.exp = [result]
  },

  // 시작 시간 String으로 변경
  parseStartTimeData (state, {val, index, key}) {
    const endExp = state.timeData.week[key].exp[index].substring(4, 8)
    const result = formatDate(val, 'HHmm') + endExp

    state.timeData.week[key].exp[index] = result
  },

  // 종료 시간 String으로 변경
  parseEndTimeData (state, {val, index, key}) {
    const startExp = state.timeData.week[key].exp[index].substring(0, 4)
    const result = startExp + formatDate(val, 'HHmm')

    state.timeData.week[key].exp[index] = result
  },

  // 시작 날짜 String으로 변경
  parseStartDateData (state, {val, index}) {
    const endExp = state.timeData.period.exp[index].substring(12, 24)
    const result = formatDate(val, 'YYYYMMDDHHmm') + endExp

    state.timeData.period.exp[index] = result
  },

  // 종료 날짜 String으로 변경
  parseEndDateData (state, {val, index}) {
    const startExp = state.timeData.period.exp[index].substring(0, 12)
    const result = startExp + formatDate(val, 'YYYYMMDDHHmm')

    state.timeData.period.exp[index] = result
  },

  // 매월 - 일자별 전체 설정
  setMonthInDaysAll (state, isAll) {
    if (isAll) {
      state.timeData.month.days = '1111111111111111111111111111111'
    } else {
      state.timeData.month.days = '0000000000000000000000000000000'
    }
  },

  // 매월 - 월별 전체 설정
  setYearsInMonthAll (state, isAll) {
    if (isAll) {
      state.timeData.year.exp = '111111111111'
    } else {
      state.timeData.year.exp = '000000000000'
    }
  },

  // 매월 사용 여부에 따라 값 설정
  changeMonthUsedData (state, data) {
    state.timeData.month.use = data
  },

  // 시간객체 복사
  copyTimeData (state) {
    const initTimeDataKeys = Object.keys(initTimeData())
    const tempData = _.pick(_.cloneDeep(state.selectedData), initTimeDataKeys)
    state.copyData = JSON.stringify(tempData)
  },

  // 시간객체 붙여넣기
  pasteTimeData (state) {
    state.timeData = JSON.parse(state.copyData)
    // Copy시에 exp에 빈값으로 인하여 validate 에러가 발생, 예외처리
    if (_.get(state.timeData, ['period', 'use'], 0) === 0) {
      _.set(state.timeData, ['period', 'exp'], [])
    }
  },

  // 시간객체 use값 변경
  setTimeDataUse (state, val) {
    _.set(state.timeData, ['month', 'use', val])
  }
}

export const actions = {
  // 시간 객체 목록 조회
  async getTimeObjectDataList ({commit, dispatch}, {loadingShow = true, loadingHide = true} = {}) {
    let url = ''
    // TAMS
    const timeObjId = 0 // 시간 객체 아이디, 0 이면 전체 조회
    url = `${cmApiPrefix}/objects/time/${timeObjId}`

    // TAMS
    const res = await this.$axios.$get(url, {loadingShow, loadingHide})

    if (res.code === 'ok') {
      commit('getTimeObjectDataList', res.result)
    }
    // TAMS
    return res
  },

  // 시간 객체 저장
  async saveTimeObjectData ({commit, dispatch, state}, {loadingShow = true, loadingHide = true, successAlert = true} = {}) {
    // TAMS
    const timeData = computedSetTimeData(state.timeData)
    timeData.time_obj_set = JSON.stringify(timeData.time_obj_set)
    // TAMS
    const res = await this.$axios.$post(`${cmApiPrefix}/objects/time`, timeData, {
      loadingShow,
      loadingHide,
      successAlert
    })

    if (res.code === 'ok') {
      // TAMS 불필요
      // commit('saveTimeObjectData', result)
      dispatch('common/common/setIsChanged', true, {root: true})
    }
    // TAMS
    return res
  },

  // 방화벽 정책에서의 시간 객체 저장
  // TAMS
  async saveFirewallTimeObjectData ({commit, dispatch, state}, {loadingShow = true, loadingHide = true, successAlert = true} = {}) {
    const
      startTime = state.timeData.period.exp[0].substring(0, 12),
      endTime = state.timeData.period.exp[0].substring(12, 24),
      timeObjectName = `Time_${startTime}_${endTime}`

    // TAMS
    const timeData = _.assign(_.cloneDeep(computedSetTimeData(state.timeData)), {
      time_obj_uname: timeObjectName,
      time_obj_desc: 'Auto created(Firewall rule)'
    })
    timeData.time_obj_set.period.use = 1
    timeData.time_obj_set = JSON.stringify(timeData.time_obj_set)

    // TAMS
    const res = await this.$axios.$post(`${cmApiPrefix}/objects/time`, timeData, {
      loadingShow,
      loadingHide,
      successAlert
    })

    if (res.code === 'ok') {
      // TAMS 불필요
      // commit('saveTimeObjectData', result)
      dispatch('common/common/setIsChanged', true, {root: true})
    }
    // TAMS
    return res
  },

  // 시간 객체 수정
  async updateTimeObjectData ({commit, dispatch, state}, {loadingShow = true, loadingHide = true, successAlert = true} = {}) {
    // TAMS
    const objectId = state.selectedData.time_obj_id
    const timeData = computedSetTimeData(state.timeData)
    timeData.time_obj_set = JSON.stringify(timeData.time_obj_set)

    // TAMS
    const res = await this.$axios.$put(`${cmApiPrefix}/objects/time/${objectId}`, timeData, {
      loadingShow,
      loadingHide,
      successAlert
    })

    if (res.code === 'ok') {
      // TAMS 불필요
      // const isShowRefsD = isShowRefs(result, state.selectedData)
      // commit('updateTimeObjectData', result)
      // // 시간 객체 수정 시 방화벽 정책에 바인딩되어 있는 시간 객체 데이터 업데이트
      // dispatch('securityPolicy/firewall/firewallPolicySettings/fwRules/updateFwInTimeObject', {result}, {root: true})
      // return {isShowRefs: isShowRefsD}
      dispatch('common/common/setIsChanged', true, {root: true})
    }
    // TAMS
    return res
  },

  // 시간 객체 조회
  async getTimeObjectData ({commit, dispatch, state}, {loadingShow = true, loadingHide = true} = {}) {
    // TAMS
    const objectId = state.selectedData.time_obj_id

    // TAMS
    const {code, result} = await this.$axios.$get(`${cmApiPrefix}/objects/time/${objectId}`, {loadingShow, loadingHide})

    if (code === 'ok') {
      commit('getTimeObjectData', result)
    }
  },

  // 시간 객체 삭제
  async deleteTimeObjectData ({commit, dispatch, state}, {loadingShow = true, loadingHide = true} = {}) {
    const objectId = state.selectedData.tm_obj_id
    let code = void 0
    let cause = void 0
    try {
      const response = await this.$axios.$delete(`${objApiPrefix}/time/objects/${objectId}`, {isReturnError: true, loadingShow, loadingHide})
      code = _.get(response, ['code'])
    } catch (e) {
      code = _.get(e, ['data', 'code'])
      cause = _.get(e, ['data', 'message'])
    }

    if (code === 'ok') {
      commit('deleteTimeObjectData', objectId)
      dispatch('common/common/setIsChanged', true, {root: true})
      commit('resetObjectSelectData')
    } else if (Number(code) === 15010) {
      const selectedData = _.cloneDeep(state.selectedData)
      return {
        notDelete: [],
        forceDelete: [selectedData]
      }
    } else {
    // } else if (Number(code) === 12004 || Number(code) === 15011) {
      const selectedData = _.cloneDeep(state.selectedData)
      return {
        notDelete: [_.assign(selectedData, {cause: cause})],
        forceDelete: []
      }
    }
  },

  // 시간 객체 일괄 삭제
  // TAMS
  async deleteBatchTimeObjectData ({commit, dispatch, state}, {forceYn = 0} = {}) {
    // TAMS
    const url = `objects/time/multi`
    const id = 'time_obj_id'
    let timeObjIdList = []
    let multiSelectedData = []
    const selectedData = _.cloneDeep(state.selectedData)

    if (_.get(selectedData, ['length'], 0) > 0) {
      timeObjIdList = _.map(selectedData, item => item[id])
      multiSelectedData = selectedData
    } else {
      timeObjIdList = [selectedData[id]]
      multiSelectedData = [selectedData]
    }
    const params = {
      time_obj_id_list: timeObjIdList,
      force_yn: forceYn
    }

    const res = await this.$axios.$put(`${cmApiPrefix}/${url}`, params, {successAlert: false})

    if (res.code === 'ok') {
      res.result.can_not_delete = _.get(res.result, ['can_not_delete'], []).map(o => _.assign(o, _.find(multiSelectedData, [id, o[id]])))
      res.result.force_delete_pass = _.get(res.result, ['force_delete_pass'], []).map(o => _.assign(o, _.find(multiSelectedData, [id, o[id]])))
      dispatch('common/common/setIsChanged', true, {root: true})
      commit('resetObjectSelectData')
    }
    return res
  },

  // 시간 객체 참조 여부 상세 조회
  // TAMS 제외 (미사용, TAMS 전용 통합 API를 통해 참조 여부 조회)
  async getTimeDetailRefData ({commit, state}, {objectData, loadingShow = true, loadingHide = true} = {}) {
    const objId = objectData.tm_obj_id
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/time/objects/${objId}/ref`, {loadingShow, loadingHide})

    if (code === 'ok') {
      commit('cm/objectSecProfile/object/objectSettings/common/setUsedDetailData', result, {root: true})
    }
  }
}

export const getters = {
}

export const strict = false
